
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/liabilities",
      function () {
        return require("private-next-pages/docs/liabilities/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/liabilities"])
      });
    }
  